import { render, staticRenderFns } from "./redAddCart.vue?vue&type=template&id=bc6884fc&scoped=true"
import script from "./redAddCart.vue?vue&type=script&lang=js"
export * from "./redAddCart.vue?vue&type=script&lang=js"
import style0 from "./redAddCart.vue?vue&type=style&index=0&id=bc6884fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6884fc",
  null
  
)

export default component.exports